import React from 'react'
import styled from 'styled-components'
import AppBody from '../AppBody'

const MainContainer = styled.div`
  display: flex;
  min-height: 100vh;

  @media (max-width: 768px) {
    min-height: 90vh;
    flex-direction: column;
  }
`

const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;

  @media (max-width: 768px) {
    align-items: flex-start;
    padding: 2rem 0;
  }
`

const ComingSoonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  text-align: center;
`

const ComingSoonCard = styled.div`
  background-color: #1a1a1a;
  border: 2px solid #2c2c2c;
  border-radius: 12px;
  padding: 3rem 2rem;
  max-width: 400px;
  width: 100%;
`

const ComingSoonText = styled.h1`
  color: #f5c518;
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
`

export default function NodeMining() {
  return (
    <MainContainer>
      <ContentContainer>
        <AppBody>
          <ComingSoonContainer>
            <ComingSoonCard>
              <ComingSoonText>Coming Soon</ComingSoonText>
            </ComingSoonCard>
          </ComingSoonContainer>
        </AppBody>
      </ContentContainer>
    </MainContainer>
  )
}
